import axios from "axios";

export const getIpAddress = async () => {
  const response = await axios.get("https://api.ipify.org?format=json");
  const ipAddress = response.data.ip;
  return ipAddress;
};
